/**
 * Field-level guidance for Administrative Info form tooltips and admin auto-populate extraction.
 */

export const ADMIN_FIELD_HOVER_INFO = {
  trial_acronym: 'Set when creating or editing the trial (Projects sidebar → Edit Trial).',
  official_title: 'Enter a full length study title for this study record.',
  short_title: 'Enter a shortened, easily identifiable title for this study record.',
  sponsor_protocol_identifier:
    'Set when creating or editing the trial (Projects sidebar → Edit Trial).',
  version_number: 'Enter the current version number of the protocol or document.',
  version_date: 'Enter the date associated with this protocol version.',
  sponsor_information_section:
    'This section collects the legal name, address, and related details of the individual, pharmaceutical/device company, academic institution, or other organization taking overall responsibility for the clinical investigation.',
  sponsor_type:
    'Select the appropriate category or type of organization acting as the sponsor, and other authorities.',
  sponsor_name_generic:
    'Enter the full legal name of the sponsor, co-sponsor, or collaborating organization as applicable.',
  sponsor_legal_address: 'Enter the official registered address of the organization.',
  investigational_product_section:
    'This section has a brief description or key details regarding the investigational product being studied.',
  sponsor_investigational_product_codes:
    'Enter the specific alphanumeric code or identifier assigned to the investigational product by the sponsor.',
  investigational_product_names:
    'Enter the official, generic, or trade name(s) of the investigational product.',
  regulatory_identifiers_section:
    'This section includes any relevant registration numbers or identifiers assigned to this clinical trial by regulatory authorities.',
  sponsor_approval_section: "This section provides the sponsor's approval status.",
  sponsor_approval_type:
    'Select whether to record the sponsor approval date or the location on the document where approval is recorded.',
  sponsor_approval_date:
    'Enter the exact date when the sponsor officially approved the study or document.',
  sponsor_approval_location:
    "Enter the specific document or section where the sponsor's official approval signature and date are recorded (e.g., Protocol Signature Page).",
  medical_expert_contact:
    'Enter the phone number, email address, and physical address of the designated medical expert overseeing the trial.',
  document_header: 'Enter the document header text as it should appear on the protocol cover page.',
};

export const REGULATORY_IDENTIFIER_HOVER_BY_TYPE = {
  nct: 'Enter the ClinicalTrials.gov NCT number assigned to this trial.',
  fda_ind: 'Enter the FDA Investigational New Drug (IND) application number, if applicable.',
  eu_ct: 'Enter the EU Clinical Trials Register / CTIS identifier, if applicable.',
  ide: 'Enter the Investigational Device Exemption (IDE) number assigned by the FDA, if applicable.',
  jrct:
    'Enter the unique alphanumeric identifier assigned to a clinical trial registered in Japan by the Japan Registry for Clinical Trials.',
  nmpa_ind:
    'Enter the Investigational New Drug (IND) number assigned by the National Medical Products Administration (NMPA), if applicable.',
  who_utn: 'Enter the Universal Trial Number (UTN) provided by the World Health Organization (WHO).',
  other:
    'Enter any additional regulatory or registry identification numbers not covered by the specific fields above.',
};

export const SPONSOR_NAME_HOVER_BY_TYPE = {
  sponsor:
    'Enter the name of the primary organization or individual legally responsible for initiating and managing the clinical investigation.',
  co_sponsor:
    'Enter the name of the entity that officially shares the management and financial responsibilities of the study alongside the main sponsor.',
  local_sponsor:
    "Enter the name of the designated regional representative responsible for overseeing the trial's compliance and administration in your specific country.",
  device_manufacturer:
    'Enter the name of the company responsible for designing, producing, and supplying the investigational medical device.',
  collaborator:
    'Enter the name of the supporting organization providing funding, resources, or expertise for the study.',
};

export const SPONSOR_ADD_HOVER_BY_TYPE = {
  sponsor: 'Click to add another sponsor to this study record.',
  co_sponsor: 'Click to add another co-sponsor to this study record.',
  collaborator: 'Click to add another collaborating organization to this study record.',
  local_sponsor: 'Click to add another local sponsor to this study record.',
  device_manufacturer: 'Click to add another device manufacturer to this study record.',
};

/** Flat map for LLM extraction prompts (admin auto-populate). */
export const buildAdministrativeExtractionGuidance = () => {
  const out = { ...ADMIN_FIELD_HOVER_INFO };
  Object.entries(REGULATORY_IDENTIFIER_HOVER_BY_TYPE).forEach(([type, text]) => {
    out[`regulatory_identifier_${type}`] = text;
  });
  Object.entries(SPONSOR_NAME_HOVER_BY_TYPE).forEach(([type, text]) => {
    out[`sponsor_name_${type}`] = text;
    out[`${type}_entries`] = text;
  });
  return out;
};
